import React, { ReactElement, useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { AppDispatch } from 'app/store';

import {
  clearErrors,
  selectGlobalError,
} from '../../captains-form/components/errors/slices/globalErrorSlice';
import { getRequiredDocuments } from '../../captains-form/slices/documentsSlice';
import {
  getPassengers,
  getPortCall,
  getPortcallStatusLog,
  selectGeneralData,
  selectPortallStatusLog,
} from '../../captains-form/slices/portCallSlice';

import Header from './Header';
import Modal from './Modal';
import Sidebar from './Sidebar';

import '../styles/layout.scss';

const Layout = ({ children }: { children: ReactElement }) => {
  const formRef = useRef<React.RefObject<unknown>>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const globalError = useSelector(selectGlobalError);
  const generalPortcallData = useSelector(selectGeneralData);
  const portallStatusLog = useSelector(selectPortallStatusLog);
  const mandatoryDocumentsFormRef = useRef<React.RefObject<unknown>>(null);
  const params = useParams();
  const { isOpenToMaster } = generalPortcallData;

  useEffect(() => {
    if (params.uid) {
      dispatch(
        getRequiredDocuments({
          uid: params.uid,
        })
      );
      dispatch(getPortCall(params.uid));
      dispatch(getPortcallStatusLog(params.uid));
      dispatch(getPassengers({ uid: params.uid, listType: 'arrival' }));
      dispatch(getPassengers({ uid: params.uid, listType: 'departure' }));
    }
  }, [dispatch, params.uid]);

  const haveToRedirectToBlockPage = useCallback(() => {
    return isOpenToMaster != null && !isOpenToMaster;
  }, [isOpenToMaster]);

  useEffect(() => {
    if (haveToRedirectToBlockPage()) {
      navigate(`/blocked`);
    }
  }, [haveToRedirectToBlockPage, navigate]);

  return (
    <div className="layout">
      <Header
        formRef={formRef}
        mandatoryDocumentsFormRef={mandatoryDocumentsFormRef}
      />
      <main>
        <Sidebar portallStatusLog={portallStatusLog} />
        {React.Children.map(children, (child) => {
          return React.cloneElement(child as React.ReactElement<any>, {
            context: { formRef, mandatoryDocumentsFormRef },
          });
        })}
      </main>
      <Modal
        className={`global-error-modal`}
        title={'Error'}
        closeTimeoutMS={1}
        showModal={globalError.hasErrors}
        onCloseModal={() => {
          dispatch(clearErrors());
        }}>
        <div className="add-cargo-modal__content">
          <p>There is an error:</p>
          {globalError.errors.map((error: string, key: number) => {
            return <pre key={`error-${key}`}>{error}</pre>;
          })}
        </div>
      </Modal>
    </div>
  );
};

export default Layout;
